export default __webpack_public_path__ + "static/media/bnbreward.5fc8b12f.png";